module.exports = __webpack_public_path__ + "static/img/3.3fe88b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/3.jpg
// module id = 11Os
// module chunks = 1